export const TABLE_FRAME = 'mx-3 hidden w-auto rounded-xl border border-border/70 md:block'
